import { TeamInfo } from 'models';

import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/current-teams';

const useTeams = () => {
    const { teams } = useSnapshot(state);

    return { teams: teams as TeamInfo[] };
};

export { useTeams };
